/**
 * 모델
 * @window w_tb_e035w_05
 * @category 월점검 비통채크현황
 */
export class MonthEmergencyCallDetailModel {
  readonly calldate: string

  readonly callnm: string

  readonly callnum: string

  readonly calltime: string

  readonly filename: string

  readonly noreply: string

  readonly quality: string

  readonly rec_recedate: string

  readonly rec_recenum: string

  readonly result: string

  readonly seq: string

  readonly seq_ai: string

  readonly size: string

  readonly sizeflag: string

  readonly sttflag: string

  constructor(data: any) {
    this.calldate = data.calldate || '';
    this.callnm = data.callnm || '';
    this.callnum = data.callnum || '';
    this.calltime = data.calltime || '';
    this.filename = data.filename || '';
    this.noreply = data.noreply || '';
    this.quality = data.quality || '';
    this.rec_recedate = data.rec_recedate || '';
    this.rec_recenum = data.rec_recenum || '';
    this.result = data.result || '';
    this.seq = data.seq || '';
    this.seq_ai = data.seq_ai || '';
    this.size = data.size || '';
    this.sizeflag = data.sizeflag || '';
    this.sttflag = data.sttflag || '';
  }
}
